// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3ANza","inputWrap":"Table_inputWrap__2HgKt","col":"Table_col__16TMn","bmiTooltip":"Table_bmiTooltip__2TOHR"};